export default "__VITE_PUBLIC_ASSET__803adbe9__"